import React from "react";
import { Controller } from "react-hook-form";
import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import "./style.css";

function CustomDatePicker({
  name,
  control,
  error,
  onChange,
  format = "d/M/yyyy",
  allowClear,
  required = true,
}) {
  const handleTimeZone = (date) => {
    const formattedDate = new Date(
      new Date(date).getTime() - new Date(date).getTimezoneOffset() * 60000
    ).toJSON();

    return formattedDate;
  };

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <DatePicker
            value={handleTimeZone(field.value)}
            format={format}
            locale="ar"
            clearIcon={allowClear}
            onChange={(date) => {
              field.onChange(handleTimeZone(date));
              onChange && onChange(handleTimeZone(date));
            }}
          />
        )}
        rules={{
          required: required && "هذا الحقل مطلوب!",
        }}
      />
      {error && (
        <small className="uk-text-danger uk-display-block uk-margin-small-top">
          <span className="uk-margin-small-left" uk-icon="warning"></span>
          {error.message}
        </small>
      )}
    </>
  );
}

export default CustomDatePicker;
